import Monitor from '@activity/monitor'
import { md5 } from 'js-md5'

// 确保样式文件下载并解析完之后再执行js代码
const preloadLinks = document.querySelectorAll(
  'link[media="print"][rel="stylesheet"]'
)
preloadLinks.forEach((link: HTMLLinkElement) => {
  link.media = 'all'
})

const ENV = process.env.ENV

window.appId = '100010017'

window.eventid = {
  eur: '100000146',
  ea: '100000147',
  sea: '100000148',
}[window.queryObj.area]

try {
  window.onemtMonitor = new Monitor({
    env: ENV !== 'production' ? 'debug' : 'production',
    appid: window.appId,
    eventid: window.eventid,
    name: 'KOW-好友召回活动',
    pkgVersion: process.env.pkgVersion,
    collectConsoleError: false,
    keyTimeClassName: 'home',
    // checkWebp: true,
    getDeviceData() {
      const sdkConfig = window.sdkConfig || ({} as SdkConfig)
      const userInfo = window.userInfo || ({} as UserInfo)
      return {
        ltDeviceId: sdkConfig.deviceId,
        ltId: userInfo.userId,
        sdkVersion: sdkConfig.clientVersion,
        webAccount: !window.inSDK ? getWebAccount() : '',
      }
    },
  })
} catch (error) {
  console.warn(error)
}

function getWebAccount() {
  let name = ''
  try {
    const loginData = JSON.parse(
      window.atob(window.localStorage.getItem(md5('1')) || window.btoa('{}'))
    )
    name = loginData.name || ''
  } catch (error) {
    console.warn(error)
  }
  return name
}

export function keyDataConsumeTimeReport(
  consumeTimeMap: Parameters<
    typeof window.onemtMonitor.keyDataConsumeTimeReport
  >[0]
) {
  if (!window.onemtMonitor) return

  window.onemtMonitor.keyDataConsumeTimeReport(consumeTimeMap)
}
